<template>
  <div class="inner-content">
    <h2 class="ttl-news-detail" data-private>{{ notification.title }}</h2>
    <p class="txt-news-date">{{ notification.displayDate | notificationDate }}</p>
    <div class="container-iframe mb20" :style="iframe.styleContainer">
      <iframe
        :src="notification.detailHTML"
        class="iframe"
        :style="iframe.styleIframe"
        frameborder="0"
        scrolling="yes"
        allowfullscreen>
      </iframe>
    </div>
    <div class="btn-cancel">
      <router-link :to="'/notifications'"><p>{{ $t('back_to_index') }}</p></router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  data() {
    return {
       iframe: {
        styleIframe: null,
        styleContainer: null
      }
    }
  },
  computed: {
    ...mapState({
      notification: state => state.notification.notification,
    })
  },
  mounted() {
    this.screenTracking(this.$t('information_details'))
    this.setHeightIframe()
  },
  methods: {
    setHeightIframe() {
      const heightScreen = window.innerHeight
      const heightAlreadyUsed = 300
      this.iframe.styleIframe = {
        height: heightScreen + 'px'
      }
      this.iframe.styleContainer = {
        height: (heightScreen - heightAlreadyUsed) + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .container-iframe {
    position: relative;
    width: 100%;
    overflow: scroll;
    padding-bottom: 20%;
 }
 .container-iframe iframe {
    width: 100%;
 }
 .iframe {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
 }
</style>